import { ACTION_TYPES, useEstoquesMedicamentoDispatch, useEstoquesMedicamentoState } from "./estoques-medicamento-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { IEstoqueMedicamentoPagedRequest } from "models/request/estoque-medicamento-paged-request";
import { downloadFile } from "utils/download-file";

export const useEstoquesMedicamentoController = () => {
    const dispatch = useEstoquesMedicamentoDispatch();
    const { estoquePagedRequest } = useEstoquesMedicamentoState();

    async function exportEstoques(format: string) {
        const file = await MunicipalPortalAAppService.exportEstoquesMedicamento(estoquePagedRequest, format);
        downloadFile(file);
    }

    async function onInit() {
        let request = { page: 0, pageSize: 10 } as IEstoqueMedicamentoPagedRequest;

        dispatch({ type: ACTION_TYPES.setEstoquePagedRequest, payload: request });
        dispatch({ type: ACTION_TYPES.setLoading, payload: true });

        await listEstoques(request);

        try {
            const ultimaAtualizacao = await MunicipalPortalAAppService.getEstoquesMedicamentoUltimaAtualizacao();
            dispatch({ type: ACTION_TYPES.setUltimaAtualizacao, payload: ultimaAtualizacao?.dtaUltimaAtualizacao ?? null });
        } catch (error) {
            console.log(error);
        }

        dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }

    async function listEstoques(request: IEstoqueMedicamentoPagedRequest, showLoading: boolean = false) {
        try {
            if (showLoading) {
                dispatch({ type: ACTION_TYPES.setLoading, payload: true });
            }
            dispatch({ type: ACTION_TYPES.setError, payload: null });

            const estoques = await MunicipalPortalAAppService.listEstoquesMedicamento(request);

            dispatch({ type: ACTION_TYPES.setEstoques, payload: estoques });
        } catch (error) {
            console.log(error);
            dispatch({ type: ACTION_TYPES.setError, payload: 'Não foi possível carregar o estoque de medicamentos. Tente novamente mais tarde.' });
        } finally {
            if (showLoading) {
                dispatch({ type: ACTION_TYPES.setLoading, payload: false });
            }
        }
    }

    const handleOnChange = (e: any) => {
        let updated = { ...estoquePagedRequest };

        if (e.target.name === "text-field-term") {
            updated.term = e.target.value;
            if (!updated.term) {
                (async () => await listEstoques({ ...updated, page: 0 }, true))();
            }
        } else if (e.target.name === "select-order-direction") {
            updated.orderDirection = e.target.value;
            (async () => await listEstoques({ ...updated, page: 0 }, true))();
        }

        dispatch({ type: ACTION_TYPES.setEstoquePagedRequest, payload: updated });
    };

    return { listEstoques, handleOnChange, onInit, exportEstoques };
}
